import { Key } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { AccountManagementMenu_OnUpdateLegacy } from '~/library/AccountManagementMenu/component';
import { PasswordSubmissionMethodForm } from '~/scenes/PeopleModule/components/EmployeeActions/ResetPassword/PasswordSubmissionMethodForm';

import { useResetPassword } from './useResetPassword';

type Props = AccountManagementMenu_OnUpdateLegacy & {
  open: boolean;
  onClose: () => void;
};

export const ResetPassword = (props: Props) => {
  const { open, onClose: onCloseDialog, onUpdateLegacy } = props;

  const { t } = useTranslation();

  const {
    form: {
      control,
      trigger,
      formState: { isSubmitted, isValid, isSubmitSuccessful },
    },
    onSubmit,
    onClose,
    isFormEnabled,
    dialogTitle,
  } = useResetPassword({ onClose: onCloseDialog, onUpdateLegacy });

  return (
    <Dialog open={open} onClose={onClose}>
      <SolaForceDialogTitle onClose={onClose} icon={<Key />}>
        {dialogTitle}
      </SolaForceDialogTitle>
      <DialogContent dividers={true}>
        {isSubmitSuccessful ? (
          <>{t('laPasswordResetOK')}</>
        ) : (
          <>
            <Typography>{t('laConfirmPasswordReset')}</Typography>
            <PasswordSubmissionMethodForm
              control={control}
              fieldNames={{
                method: 'passwordSubmit.method',
                workEmail: 'passwordSubmit.workEmail',
                mobile: 'passwordSubmit.mobile',
                alternateEmail: 'passwordSubmit.alternateEmail',
              }}
              triggerRevalidate={trigger}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color={'secondary'}>
          {t('cancel')}
        </Button>
        {!isSubmitSuccessful && (
          <Button
            onClick={onSubmit}
            disabled={(isSubmitted && !isValid) || !isFormEnabled}
          >
            {t('laSend')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
